import IconButton from "@material-ui/core/IconButton";
import Paper from "@material-ui/core/Paper";
import { withStyles } from "@material-ui/core/styles";
import { lighten } from "@material-ui/core/styles/colorManipulator";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import TextField from "@material-ui/core/TextField";
import Toolbar from "@material-ui/core/Toolbar";
import Tooltip from "@material-ui/core/Tooltip";
import Typography from "@material-ui/core/Typography";
import DeleteIcon from "@material-ui/icons/Delete";
import SaveIcon from "@material-ui/icons/Save";
import classNames from "classnames";
import PropTypes from "prop-types";
import React from "react";

import * as dateTime from "./../../helper/date";
import datetimeHelper from "./../../helper/datetime-helper";
import { globalHistory } from "./../../history";

function desc(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function stableSort(array, cmp) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = cmp(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

function getSorting(order, orderBy) {
  return order === "desc"
    ? (a, b) => desc(a, b, orderBy)
    : (a, b) => -desc(a, b, orderBy);
}

function filterItems(array, query) {
  return array.filter((item) => {
    return item.phonenumber.search(new RegExp(query.trim(), "i")) !== -1;
  });
}

const rows = [
  {
    id: "phonenumber",
    numeric: false,
    disablePadding: false,
    label: "Số điện thọai gọi",
  },
  {
    id: "pbxNumber",
    numeric: false,
    disablePadding: false,
    label: "Số điện thoại nhận",
  },
  {
    id: "duration",
    numeric: false,
    disablePadding: false,
    label: "Thời lượng",
  },
  {
    id: "startedAt",
    numeric: false,
    disablePadding: false,
    label: "Thời gian bắt đầu",
  },
  { id: "recordUrl", numeric: false, disablePadding: false, label: "Ghi âm" },
  { id: "state", numeric: false, disablePadding: false, label: "Trạng thái" },
  // { id: 'action', numeric: false, disablePadding: false, label: 'Action' },
];

class EnhancedTableHead extends React.Component {
  state = {
    isShow: true,
    search: "",
  };
  createSortHandler = (property) => (event) => {
    this.props.onRequestSort(event, property);
  };

  render() {
    const { order, orderBy } = this.props;

    return (
      <TableHead>
        <TableRow>
          {rows.map((row) => {
            return (
              <TableCell
                key={row.id}
                numeric={row.numeric}
                padding="dense"
                sortDirection={orderBy === row.id ? order : false}>
                <Tooltip
                  title="Sort"
                  placement={row.numeric ? "bottom-end" : "bottom-start"}
                  enterDelay={300}>
                  <TableSortLabel
                    active={orderBy === row.id}
                    direction={order}
                    onClick={this.createSortHandler(row.id)}>
                    {row.label}
                  </TableSortLabel>
                </Tooltip>
              </TableCell>
            );
          }, this)}
        </TableRow>
      </TableHead>
    );
  }
}

EnhancedTableHead.propTypes = {
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.string.isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

const toolbarStyles = (theme) => ({
  root: {
    paddingRight: theme.spacing.unit,
  },
  highlight:
    theme.palette.type === "light"
      ? {
          color: theme.palette.secondary.main,
          backgroundColor: lighten(theme.palette.secondary.light, 0.85),
        }
      : {
          color: theme.palette.text.primary,
          backgroundColor: theme.palette.secondary.dark,
        },
  spacer: {
    flex: "1 1 100%",
  },
  actions: {
    color: theme.palette.text.secondary,
    flexDirection: "row",
    display: "flex",
  },
  title: {
    flex: "0 0 auto",
  },
  form: {
    marginRight: 25,
    width: 250,
  },
  searchForm: {
    display: "flex",
  },
  searchInput: {
    marginRight: 25,
    width: 200,
  },
});

let EnhancedTableToolbar = (props) => {
  const { numSelected, classes } = props;
  return (
    <Toolbar
      className={classNames(classes.root, {
        [classes.highlight]: numSelected > 0,
      })}>
      <div className={classes.title}>
        {numSelected > 0 ? (
          <Typography color="inherit" variant="subheading">
            {numSelected} selected
          </Typography>
        ) : (
          <Typography variant="title" id="tableTitle">
            Lịch sử cuộc gọi vào
          </Typography>
        )}
      </div>
      <div className={classes.spacer} />
      <div className={classes.actions}>
        {numSelected > 0 ? (
          <div className={classes.actions}>
            <Tooltip title="Save">
              <IconButton aria-label="Save">
                <SaveIcon />
              </IconButton>
            </Tooltip>
            <Tooltip title="Delete">
              <IconButton aria-label="Delete">
                <DeleteIcon />
              </IconButton>
            </Tooltip>
          </div>
        ) : (
          <div className={classes.searchForm}>
            <TextField
              id="searchPhone"
              name="searchPhone"
              label="Số điện thoại"
              margin="normal"
              variant="outlined"
              className={classes.searchInput}
              onChange={props.searchForm}
            />
          </div>
        )}
      </div>
    </Toolbar>
  );
};

EnhancedTableToolbar.propTypes = {
  classes: PropTypes.object.isRequired,
  numSelected: PropTypes.number.isRequired,
  searchForm: PropTypes.func,
};

EnhancedTableToolbar = withStyles(toolbarStyles)(EnhancedTableToolbar);

const styles = (theme) => ({
  root: {
    width: "100%",
  },
  table: {
    minWidth: 1020,
    // marginLeft: 50,
    // margin: 0
  },
  tableWrapper: {
    overflowX: "auto",
  },
  button: {
    margin: theme.spacing.unit,
  },
  audioStyle: {
    width: 115,
  },
});

class DataTable extends React.Component {
  state = {
    order: "asc",
    orderBy: "calories",
    selected: [],
    page: 0,
    rowsPerPage: 20,
    search: "",
    isShow: false,
    startDate: new Date(),
  };

  componentDidMount() {
    this.history = globalHistory();
  }

  handleChange = (name) => (event) => {
    this.setState({ [name]: event.target.checked });
  };

  handleRequestSort = (event, property) => {
    const orderBy = property;
    let order = "desc";

    if (this.state.orderBy === property && this.state.order === "desc") {
      order = "asc";
    }

    this.setState({ order, orderBy });
  };

  handleSelectAllClick = (event) => {
    const { inBounds } = this.props;

    if (event.target.checked) {
      this.setState((state) => ({ selected: inBounds.map((n) => n.id) }));
      return;
    }
    this.setState({ selected: [] });
  };

  handleClick = (event, id) => {
    const { selected } = this.state;
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }

    this.setState({ selected: newSelected });
  };

  handleChangePage = (event, page) => {
    this.setState({ page });
  };

  handleChangeRowsPerPage = (event) => {
    this.setState({ rowsPerPage: event.target.value });
  };

  isSelected = (id) => this.state.selected.indexOf(id) !== -1;

  itemDetail(item) {
    this.history.push(`/inBounds/${item.id}`);
  }

  handleSearch = (name) => {
    return (e) => {
      const value = e.target.value;
      this.setState({
        [name]: value,
      });
    };
  };

  render() {
    const { classes, inBounds } = this.props;
    const { order, orderBy, selected, rowsPerPage, page } = this.state;
    const emptyRows =
      rowsPerPage - Math.min(rowsPerPage, inBounds.length - page * rowsPerPage);
    return (
      <Paper className={classes.root}>
        <EnhancedTableToolbar searchForm={this.handleSearch("search")} />
        <div className={classes.tableWrapper}>
          <Table className={classes.table} aria-labelledby="tableTitle">
            <EnhancedTableHead
              numSelected={selected.length}
              order={order}
              orderBy={orderBy}
              // onSelectAllClick={this.handleSelectAllClick}
              onRequestSort={this.handleRequestSort}
              rowCount={inBounds.length}
            />
            <TableBody>
              {stableSort(
                filterItems(inBounds, this.state.search),
                getSorting(order, orderBy)
              )
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((n) => {
                  const isSelected = this.isSelected(n.id);
                  const checkState =
                    n.state === "Available" ? "Hoạt động" : "Tạm dừng";
                  const date = dateTime.formatDate(
                    n.startedAt,
                    dateTime.dateFormats.isoDate
                  );
                  return (
                    <TableRow hover key={n.id} selected={isSelected}>
                      <TableCell component="th" scope="row" padding="dense">
                        {n.phonenumber}
                      </TableCell>
                      <TableCell component="th" scope="row" padding="dense">
                        {n.pbxNumber}
                      </TableCell>
                      <TableCell component="th" scope="row" padding="dense">
                        {datetimeHelper.secondToHHMMSS(n.duration)}
                      </TableCell>
                      <TableCell component="th" scope="row" padding="dense">
                        {n.startedAt ? date : null}
                      </TableCell>
                      <TableCell component="th" scope="row" padding="dense">
                        {n.recordUrl !== "null" ? (
                          <audio
                            ref="audio"
                            src={n.recordUrl}
                            controls
                            autoPlay={false}
                          />
                        ) : (
                          <div>Not found</div>
                        )}
                      </TableCell>
                      <TableCell component="th" scope="row" padding="dense">
                        {n.state}
                      </TableCell>
                      {/* <TableCell component="th" scope="row" padding="dense">
                                                <Button variant="fab" mini color="primary" className={classes.button} onClick={this.itemDetail.bind(this, n)}>
                                                    <SearchIcon />
                                                </Button>
                                            </TableCell> */}
                    </TableRow>
                  );
                })}
              {emptyRows > 0 && null}
            </TableBody>
          </Table>
        </div>
        <TablePagination
          component="div"
          count={inBounds.length}
          rowsPerPage={rowsPerPage}
          rowsPerPageOptions={[20, 50, 100, 200, 500]}
          page={page}
          backIconButtonProps={{
            "aria-label": "Previous Page",
          }}
          nextIconButtonProps={{
            "aria-label": "Next Page",
          }}
          onChangePage={this.handleChangePage}
          onChangeRowsPerPage={this.handleChangeRowsPerPage}
        />
      </Paper>
    );
  }
}

DataTable.propTypes = {
  classes: PropTypes.object.isRequired,
  inBounds: PropTypes.array,
};

DataTable.defaultProps = {
  inBounds: [],
};

export default withStyles(styles)(DataTable);
